import { LoginMethod } from "recoil/loginHintAtom";

export type LoginPlatform = "web" | "androidApp" | "iosApp";

// 접힘 대상 판별: 웹(모바일 웹 포함)과 Android 앱만 접힘, iOS 앱은 현행 유지.
// 인앱인데 OS 판별이 모호하면 iosApp(=현행 유지) 쪽으로 폴백.
export function resolveLoginPlatform(
  isInApp: boolean,
  isAndroid: boolean
): LoginPlatform {
  if (!isInApp) return "web";
  return isAndroid ? "androidApp" : "iosApp";
}

// 플랫폼별 펼침 순서 (Figma 8529-15562: 1행 웹, 2행 Android, 3행 iOS)
const EXPANDED_ORDER: Record<LoginPlatform, readonly LoginMethod[]> = {
  web: ["kakao", "apple", "google"],
  androidApp: ["kakao", "google", "apple"],
  iosApp: ["kakao", "apple", "google"],
};

export interface LoginButtonLayout {
  collapsible: boolean; // false = 접힘 없음 (iOS 앱)
  order: LoginMethod[]; // [대표, ...나머지]; 접힘 상태에선 order[0]만 노출
}

export function getLoginButtonLayout(
  platform: LoginPlatform,
  loginHint: LoginMethod | undefined
): LoginButtonLayout {
  const baseOrder = EXPANDED_ORDER[platform];
  const collapsible = platform !== "iosApp";

  // "최근 로그인" 힌트가 있으면 그 수단을 대표(맨 앞)로 이동. iOS 앱은 순서 불변.
  const order =
    collapsible && loginHint
      ? [loginHint, ...baseOrder.filter((method) => method !== loginHint)]
      : [...baseOrder];

  return { collapsible, order };
}
